  // Add event listener to document for clicks on elements with class 'impact-point-heading'
document.addEventListener('click', function(event) { 
  // Check if the clicked element or its parent has the class
  var clickedElement = event.target.closest('.impact-point-heading');
  
  if (clickedElement) {
    // Change background image
    var tabimagedesktop = clickedElement.getAttribute('data-img-desktop');
    var tabimagemobile = clickedElement.getAttribute('data-img-mobile');

    var sourceDesktop = document.querySelector('.impact-points-bg source[media="(min-width:466px)"]');
    var sourceMobile = document.querySelector('.impact-points-bg source[media="(max-width:465px)"]');

    if (sourceDesktop) {
      sourceDesktop.setAttribute('srcset', tabimagedesktop);
    }
    if (sourceMobile) {
      sourceMobile.setAttribute('srcset', tabimagemobile);
    }

    // Toggle active class for headings
    var headings = document.querySelectorAll('.impact-point-heading');
    headings.forEach(function(heading) {
      heading.classList.remove('active');
    });
    clickedElement.classList.add('active');

    // Toggle active class for descriptions
    var descriptions = document.querySelectorAll('.impact-point-description');
    descriptions.forEach(function(description) {
      description.classList.remove('active');
    });

    // Add active class to siblings of clicked element
    var siblingElements = Array.from(clickedElement.parentNode.children).filter(function(child) {
      return child !== clickedElement;
    });
    siblingElements.forEach(function(sibling) {
      sibling.classList.add('active');
    });
  }
});
